const COMPONENT_NAME = "ListItem";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error:`;
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR
};
